module.exports = __webpack_public_path__ + "img/transmission-icon.32558ae0.png";